@if (layout() === 'row') {
  <div
    class="g-filter-row rounded-xs"
    [class.is-linked]="linked()"
    [attr.data-path-node]="condition().id"
    [class.outline]="invalid()"
    [class.outline-offset-2]="invalid()"
    [class.outline-danger]="invalid()"
    [attr.data-invalid]="invalid() || null">
    <div class="min-w-0">
      <label class="sr-only" [for]="fieldId()">{{
        'features.data.path_filter.condition.field' | translate
      }}</label>
      <app-select
        [id]="fieldId()"
        [items]="fieldItems()"
        [value]="field()?.key ?? null"
        [searchable]="true"
        [placeholder]="'features.data.path_filter.condition.field' | translate"
        (valueChange)="onField($event)" />
      @if (field()?.keyed; as keyed) {
        <app-entity-auto-complete
          class="mt-1.5"
          [value]="key()"
          [entityType]="keyed.by"
          [isArray]="false"
          (valueChange)="onKey($event)" />
      }
    </div>
    <div class="min-w-0">
      <label class="sr-only" [for]="operatorId()">{{
        'features.data.path_filter.condition.operator' | translate
      }}</label>
      <app-select
        [id]="operatorId()"
        [items]="operatorItems()"
        [value]="condition().op"
        [disabled]="!field()?.operators?.length"
        [placeholder]="'features.data.path_filter.condition.operator' | translate"
        (valueChange)="onOperator($event)" />
    </div>
    <app-path-filter-value
      [field]="field()"
      [conditionId]="condition().id"
      [ownerEntityType]="ownerEntityType()"
      [op]="condition().op"
      [arg]="condition().arg"
      [context]="context()"
      (argChange)="onArg($event)"
      (switchOperator)="onOperator($event)" />
    <button
      type="button"
      class="text-text-tertiary hover:text-danger hover:bg-danger-soft mt-0.5 inline-flex cursor-pointer rounded-xs p-1.5 transition-colors"
      [attr.aria-label]="'features.data.path_filter.condition.remove' | translate"
      (click)="removed.emit()">
      <i [class]="ICONS.trash" aria-hidden="true"></i>
    </button>
  </div>
} @else {
  <div
    class="flex w-72 flex-col gap-2 rounded-xs p-1"
    [class.outline]="invalid()"
    [class.outline-offset-2]="invalid()"
    [class.outline-danger]="invalid()"
    [attr.data-invalid]="invalid() || null">
    <div
      class="border-weak text-text-secondary flex flex-wrap items-center gap-1.5 border-b pb-1.5 text-xs">
      <span class="text-text-primary shrink-0 font-semibold">{{ fieldName() }}</span>
      @if (field()?.keyed; as keyed) {
        <app-entity-auto-complete
          class="basis-full"
          [value]="key()"
          [entityType]="keyed.by"
          [isArray]="false"
          (valueChange)="onKey($event)" />
      }
      <label class="sr-only" [for]="operatorId()">{{
        'features.data.path_filter.condition.operator' | translate
      }}</label>
      <app-select
        class="min-w-0 flex-1"
        [id]="operatorId()"
        [items]="operatorItems()"
        [value]="condition().op"
        [disabled]="!field()?.operators?.length"
        (valueChange)="onOperator($event)" />
    </div>
    <app-path-filter-value
      layout="stacked"
      [field]="field()"
      [conditionId]="condition().id"
      [ownerEntityType]="ownerEntityType()"
      [op]="condition().op"
      [arg]="condition().arg"
      [context]="context()"
      (argChange)="onArg($event)"
      (switchOperator)="onOperator($event)" />
  </div>
}
